import React               from 'react'
import { Alert }           from 'react-bootstrap'
import { withRouter }      from 'react-router'

import { BadRequestError } from 'lib/errors'
import { Panel           } from 'alto-react-components/lib/components'
import { withAuthMessage } from 'alto-react-base-auth/lib/utils'
import { withAuthContext } from 'alto-react-base-auth/lib/components'

import ProfileForm         from './profile_form'

class ProfilePanel extends React.Component
  constructor: (props) ->
    super(props)

    @state = { client: null, clientType: null, info: null, errors: {} }

  componentWillMount: ->
    @context.auth.getClient().then (result) =>
      @setState({ client: result.client, clientType: result.type })

  render: ->
    <Panel id="edit-profile-panel" className="auth-panel left" header="Editace profilu" bsStyle="info">
      {@infoAlert()}
      {@incompleteProfileAlert()}
      {@form()}
    </Panel>

  infoAlert: ->
    <Alert id='edit-profile-info' bsStyle='success'>{@state.info}</Alert> if @state.info

  incompleteProfileAlert: ->
    if not @context.auth.isProfileComplete
      <Alert bsStyle='danger'>
        Pro pokračování do zbytku aplikace nejprve vyplňte všechna povinná pole profilu.
      </Alert>

  form: ->
    if @state.client
      <ProfileForm action='update' record={@state.client} submit={@updateProfile}
                   disableJunior={@state.clientType == 'J' and @disableJunior}
                   deleteAccount={@deleteAccount} backendErrors={@state.errors} />
    else
      <Alert>Načítám profil, vyčkejte prosím</Alert>

  updateProfile: (attributes) =>
    @context.auth.editClient(attributes)
      .then ({ user, client, isComplete, isCompleteDetail }) =>
        @setState({ client, info: 'Váš profil byl úspěšně aktualizován' })

        @props.history.push(withAuthMessage('/', 'profile_update_successful', 'success')) if isComplete

        null # otherwise runaway promise
      .catch BadRequestError, (error) =>
        { client, user } = error.data

        errors = client or {}

        if user
          errors.email = (errors.email or []).concat(user.email or []).concat(user.username or [])

        @setState({ errors })

  disableJunior: =>
    @context.auth.setClientType('C').then =>
      @setState(clientType: 'C', info: 'Mód Junior Bakarty byl ukončen')

  deleteAccount: (clearSensitiveData = false) =>
    @context.auth.deleteUser(@context.auth.loggedInClient.clientId, clearSensitiveData).then =>
      @context.auth.logOut()
      @props.history.push(withAuthMessage('/', 'account_delete_successful', 'success'))

      null # otherwise runaway promise

export default withRouter(withAuthContext(ProfilePanel))
